import React from 'react';

import { SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MONTHS_LIST } from '../../constants/date.constant';
import { ControlSx } from '../../types/control.type';
import { translateSelectList } from '../../utils/translate.utils';
import FormSelect from '../FormSelect';

type IProps = ControlSx & {
  value: string;
  name?: string;
  onChange: <T>(event: SelectChangeEvent<T>) => void;
  useEmptyValue?: boolean;
};

const FormMonthSelect = React.memo(({ name = 'month', useEmptyValue = true, ...props }: IProps) => {
  const { t } = useTranslation();

  return (
    <FormSelect
      label={t('general.month')}
      name={name}
      items={translateSelectList(MONTHS_LIST, t)}
      useEmptyValue={useEmptyValue}
      {...props}
    />
  );
});

export default FormMonthSelect;
